import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  VideoCameraOutlined,
  ArrowRightOutlined,
  BankOutlined,
} from "@ant-design/icons";

import "./jobListingEvents.scss";
import useNuJobsStore from "../../../store/nujobs.store";

const JobListingEvents = () => {
  const navigate = useNavigate();
  const { upcomingEvents,nuJobsUpcomingEvents,nuJobsGetJDandEvent } = useNuJobsStore();

  useEffect(() => {
      // Fetch hiring companies from the store or API
      // This is just a placeholder; replace with actual data fetching logic
      // setHiringCompanies(fetchedCompanies);
      nuJobsUpcomingEvents(0)
    }, []);


  const handleNavigate = (qhoid, qhjid) => {
    var source = "viewevent"
    navigate(`/nujobsViewJobsContainerOpenSearch/${source}/${qhjid}/${qhoid }`);
  };

  const handleEventClick = (event) => {
    nuJobsGetJDandEvent(event.qhoid,event.qhcompanyjid,handleNavigate );
  };


  const handleViewAll = () => {
    navigate("/nujobsupcomingevents");
  };

  return (
    <section className="nujobs-home-events">

      {/* Header */}
      <div className="nujobs-home-events-header">

        <div className="nujobs-home-events-title">
          <CalendarOutlined />

          <div>
            <p>
              Walk-ins, virtual hiring drives and job fairs.
            </p>
          </div>
        </div>

        <button
          className="events-view-all"
          onClick={handleViewAll}
        >
          View All Events
          <ArrowRightOutlined />
        </button>

      </div>

      {/* Event Cards */}
      <div className="nujobs-home-events-grid">

        {upcomingEvents?.slice(0, 3).map((event) => (

          <div
            className="nujobs-home-event-card"
            key={event.qhcompanyjid}
          >

            <div className="event-card-header">

              <span
                className={`event-type ${event.eventtype.toLowerCase()}`}
              >
                {event.eventtype}
              </span>

              <div className="event-date">
                <CalendarOutlined />
                {event.startdate }/{event.starttime }
              </div>

            </div>

            <div className="event-card-content">

              <h3>{event.eventname}</h3>

              <div className="event-company">
                <BankOutlined />
                <span>{event.companyname}</span>
              </div>

              <div className="event-info">

                <div>
                  {event.mode === "ONLINE" ? (
                    <VideoCameraOutlined />
                  ) : (
                    <EnvironmentOutlined />
                  )}

                  <span>{event.city}</span>
                </div>

                <div className="event-experience">
                  {event.experience}
                </div>

              </div>

            </div>

            <div className="event-card-footer">

              <button
                onClick={() => handleEventClick(event)}
              >
                View Details
                <ArrowRightOutlined />
              </button>

            </div>

          </div>

        ))}

      </div>

      {/* Mobile View All */}
      <button
        className="events-view-all-mobile"
        onClick={handleViewAll}
      >
        View All Hiring Events
        <ArrowRightOutlined />
      </button>

    </section>
  );
};

export default JobListingEvents;